import { DateRangePicker, Input, Select, Text, type TypeSelectOption } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import { SearchFilter } from '~/components/common';

import { CLAIM_EXCHANGE_TYPE, KEYWORD_PLACE_HOLDER } from '~/constants/claim';
import { OPTION_ALL } from '~/constants/common';

import type {
  TypeExchangeSearchFilterOptions,
  TypeExchangeSearchFilterValues,
  TypeExchangeSearchFilterValuesState,
} from '~/types/claim.types';

import styles from './ClaimExchangeFilter.module.scss';

const ClaimExchangeFilter = ({
  options,
  values,
  valuesState,
  onChange,
  onChangeStatus,
  onSearch,
  onReset,
}: {
  options: TypeExchangeSearchFilterOptions;
  values: TypeExchangeSearchFilterValues;
  valuesState: TypeExchangeSearchFilterValuesState;
  onChange: (values: Partial<TypeExchangeSearchFilterValues>) => void;
  onChangeStatus: (values: Partial<TypeExchangeSearchFilterValuesState>) => void;
  onSearch: () => void;
  onReset: () => void;
}) => {
  return (
    <SearchFilter formId="claim-exchange-search-form" onSubmit={onSearch} onReset={onReset}>
      <div className={clsx(styles['filter-container'], styles['filter-keyword'])}>
        <Text size="small" weight="semi-bold" element="p">
          키워드
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            placeholder="선택"
            options={options.keyword}
            value={values.keywordType}
            onChange={(_: unknown, value: TypeSelectOption<string>) => {
              if (value?.value === values.keywordType?.value) return;
              onChange({ keywordType: value, keyword: '' });
              onChangeStatus({ keyword: 'default' });
            }}
          />
          <Input
            type="text"
            size="small"
            placeholder={KEYWORD_PLACE_HOLDER[values.keywordType?.value as keyof typeof KEYWORD_PLACE_HOLDER] || '입력'}
            status={valuesState.keyword}
            value={values.keyword}
            onChange={(e) => onChange({ keyword: e.target.value })}
            onBlur={(e) => onChange({ keyword: e.target.value.trim() })}
            onFocus={() => onChangeStatus({ keyword: 'default' })}
          />
        </div>
      </div>
      <div className={clsx(styles['filter-container'], styles['filter-date'])}>
        <Text size="small" weight="semi-bold" element="p">
          접수일
        </Text>
        <div className={styles['input-container']}>
          <DateRangePicker
            size="small"
            placeholder={{ start: '시작일', end: '종료일' }}
            status={valuesState.exchangeDate}
            value={values.exchangeDate}
            onChange={(value) => {
              onChange({ exchangeDate: value as { start: Date; end: Date } | null });
            }}
            onFocus={() => onChangeStatus({ exchangeDate: 'default' })}
          />
        </div>
      </div>
      <div className={clsx(styles['filter-container'], styles['filter-status'])}>
        <Text size="small" weight="semi-bold" element="p">
          교환상태
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            placeholder="선택"
            options={options.exchangeStatus}
            value={values.exchangeStatus}
            onChange={(_: unknown, value: TypeSelectOption<string>) => onChange({ exchangeStatus: value })}
          />
        </div>
      </div>
      <div className={clsx(styles['filter-container'], styles['filter-exchange-type'])}>
        <Text size="small" weight="semi-bold" element="p">
          선교환여부
        </Text>
        <div className={styles['input-container']}>
          <Select
            size="small"
            placeholder="선택"
            options={[OPTION_ALL, ...Object.values(CLAIM_EXCHANGE_TYPE)]}
            value={values.exchangeType}
            onChange={(_: unknown, value: TypeSelectOption<string>) => onChange({ exchangeType: value })}
          />
        </div>
      </div>
    </SearchFilter>
  );
};

export default ClaimExchangeFilter;
